import React from 'react'
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { useTheme } from '@emotion/react';
import { tokens } from '../../theme';
import { MdWork } from "react-icons/md";
import { SiGooglescholar } from "react-icons/si";
import { Typography } from '@mui/material';

const Experience = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
  return (
      <VerticalTimeline>
          {/* <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
              contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
              date="2011 - present"
              iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
              icon={<MdWork />}
          >
              <Typography className="vertical-timeline-element-title" color={`${colors.primary[400]}`}>Creative Director</Typography>
              <Typography className="vertical-timeline-element-subtitle" color={`${colors.primary[400]}`}>Miami, FL</Typography>
              <Typography color={`${colors.primary[400]}`}>
                  Creative Direction, User Experience, Visual Design, Project Management, Team Leading
              </Typography>
          </VerticalTimelineElement>
          <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date="2010 - 2011"
              iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
              icon={<MdWork />}
          >
              <Typography className="vertical-timeline-element-title" color={`${colors.primary[400]}`}>Art Director</Typography>
              <Typography className="vertical-timeline-element-subtitle" color={`${colors.primary[400]}`}>San Francisco, CA</Typography>
              <Typography color={`${colors.primary[400]}`}>
                  Creative Direction, User Experience, Visual Design, SEO, Online Marketing
              </Typography>
          </VerticalTimelineElement> */}
          {/* <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
              contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
              date="2011 - present"
              iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
              icon={<MdWork />}
          >
              <Typography className="vertical-timeline-element-title" color={`${colors.primary[400]}`}>Web Designer</Typography>
              <Typography className="vertical-timeline-element-subtitle" color={`${colors.primary[400]}`}>Los Angeles, CA</Typography>
              <Typography color={`${colors.primary[400]}`}>
                  User Experience, Visual Design
              </Typography>
          </VerticalTimelineElement> */}
          <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
              contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
              date="2023 - present"
              iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
              icon={<MdWork />}
          >
              <Typography className="vertical-timeline-element-title" color={`${colors.primary[400]}`}>Web Developer</Typography>
              <Typography className="vertical-timeline-element-subtitle" color={`${colors.primary[400]}`}>Indo-MIM,Tirupati</Typography>
              <Typography color={`${colors.primary[400]}`}>
                  Web Based Application,Service,Support
              </Typography>
          </VerticalTimelineElement>
          <VerticalTimelineElement
              className="vertical-timeline-element--education"
              date="May 2020"
              iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
              icon={<SiGooglescholar />}
          >
              <Typography className="vertical-timeline-element-title" color={`${colors.primary[400]}`}>Audisankara College Of Engineering And Technology</Typography>
              <Typography className="vertical-timeline-element-subtitle" color={`${colors.primary[400]}`}>B.Tech</Typography>
              <Typography color={`${colors.primary[400]}`}>
                    Bachelor's
              </Typography>
          </VerticalTimelineElement>
          <VerticalTimelineElement
              className="vertical-timeline-element--education"
              date="May 2019"
              iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
              icon={<SiGooglescholar />}
          >
              <Typography className="vertical-timeline-element-title" color={`${colors.primary[400]}`}>Isuzu motors Pvt LTD</Typography>
              <Typography className="vertical-timeline-element-subtitle" color={`${colors.primary[400]}`}>Internship</Typography>
              <Typography color={`${colors.primary[400]}`}>
                   User Experience
              </Typography>
          </VerticalTimelineElement>
          <VerticalTimelineElement
              className="vertical-timeline-element--education"
              date="2016 - 2019"
              iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
              icon={<SiGooglescholar />}
          >
              <Typography variant='h3' className="vertical-timeline-element-title" color={`${colors.primary[400]}`}>Aries Polytechnic college</Typography>
              <Typography className="vertical-timeline-element-subtitle" color={`${colors.primary[400]}`}>Diploma</Typography>
              <Typography color={`${colors.primary[400]}`}>
                  Techincal Knowlwdge
              </Typography>
          </VerticalTimelineElement>
          {/* <VerticalTimelineElement
              iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
              icon={<SiGooglescholar />}
          /> */}
      </VerticalTimeline>
  )
}

export default Experience